import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Text } from '@paygreen/paygreen-ui';
import { spaces } from '../../../../utils/constants';
import { formatCentsMoney } from '../../../../utils/tools';

/**
 * @description all data properly displayed if this account has billing data linked to a specific space
 */
const SpaceManagementBillingData = ({ t, mode, name, subscriptionData }) => {
    switch (name) {
        case mode + 'KitSetupPrice':
            return (
                <Text textSize="xs">
                    {formatCentsMoney(
                        subscriptionData?.['setup_price'] || 0,
                        true,
                    )}
                    €&nbsp;HT
                </Text>
            );
        case mode + 'KitSubscriptionMode':
            return (
                <Text textSize="xs">
                    {subscriptionData?.mode &&
                        t(
                            `admin.user.subscriptionMode.${subscriptionData.mode}`,
                        )}
                    &nbsp;
                    {subscriptionData?.price !== null ? (
                        <Text htmlTag="span" textSize="xs">
                            ({formatCentsMoney(subscriptionData?.price, true)}
                            €&nbsp;HT)
                        </Text>
                    ) : null}
                </Text>
            );
        default:
            return null;
    }
};

SpaceManagementBillingData.propTypes = {
    mode: PropTypes.oneOf(Object.values(spaces)).isRequired,
    name: PropTypes.string.isRequired,
    subscriptionData: PropTypes.object,
};

SpaceManagementBillingData.defaultProps = {
    subscriptionData: null,
};

export default withTranslation('common')(SpaceManagementBillingData);
